import script from "./BaoYouLiangList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaoYouLiangList.vue?vue&type=script&lang=ts&setup=true"

import "./BaoYouLiangList.vue?vue&type=style&index=0&id=636c190e&lang=scss"

const __exports__ = script;

export default __exports__